import router from '../routes/router'
import Vue from 'vue'

export default {
    // to logout an authenticated user
    logout(state) {
        state.isLoggedin = false
        localStorage.removeItem('app_user_tokens')
        localStorage.removeItem('app_user')
        Vue.prototype.$currentUser = null
    },

    // to save the auth tokens to localStorage
    setAuthTokens(state, tokens){
        if(tokens.token && tokens.refreshtoken){
            localStorage.setItem('app_user_tokens',JSON.stringify(tokens))
            state.isLoggedIn = true
        }
    },

    setCurrentUser(state, user){
        localStorage.setItem('app_user', user)
        Vue.prototype.$currentUser = JSON.parse(user); 
        
        // check for user roles and send to appropriate dashboard
        let roles = Vue.prototype.$currentUser.roles
        
        if(roles.some( role => role == 'admin'))
            router.push('/dashboard/admin')
        else if(roles.some( role => role == 'student'))
            router.push('/dashboard/student')
        else if(roles.some( role => role == 'teacher'))
            router.push('/dashboard/teacher')
        else
            router.push('/dashboard')
    },

    setPreferences(state, preferences){
        localStorage.setItem('app_user_preferences', JSON.stringify(preferences))
    },

    setPermissions(state, permissions){
        state.permissions = permissions
    },

    setDepartments(state, departments){
        state.departments = departments
    },

    setDeaneries(state, deaneries){
        state.deaneries = deaneries
    },

    setSalutations(state, salutations){
        state.salutations = salutations
    },

    setDesignations(state, designations){
        state.designations = designations
    },

    setProgrammeTypes(state, programmeTypes){
        state.programmeTypes = programmeTypes
    },

    setTopics(state, topics){
        state.topics = topics
    },

    setBatches(state, batches){
        state.batches = batches
    },

    setPermissions(state, permissions){
        state.permissions = permissions
    },

    setRoles(state, roles){
        state.roles = roles
    },
    setRole(state, role){
        state.role = role
    },

    setMiscs(state, miscs){
        state.miscs = miscs
    },
    setMisc(state, misc){
        state.misc = misc
    },

    setCourses(state, courses){
        state.courses = courses
    },
    setCourse(state, course){
        state.course = course
    },

    setPapers(state, papers){
        state.papers = papers
    },
    setPaper(state, paper){
        state.paper = paper
    },
    setAllStudents(state, students){
        state.all_students = students
    },
    setStudents(state, students){
        state.students = students
    },
    setStudent(state, student){
        state.student = student
    },

    setTeachers(state, teachers){
        state.teachers = teachers
    },
    setTeacher(state, teacher){
        state.teacher = teacher
    },

    setProgrammes(state, programmes){
        state.programmes = programmes
    },
    setProgramme(state, programme){
        state.programme = programme
    },

    setEvent(state, event){
        state.event = event
    },

    setRegistrations(state, registrations){
        state.registrations = registrations
    },

    setNews(state, news){
        state.news = news
    },
    setNew(state, news){
        state.new = news
    },

    setVolumes(state, volumes){
        state.volumes = volumes
    },
    setNewsletterTree(state, tree){
        state.tree = tree
    },
    setNewsletters(state, newsletters){
        state.newsletters = newsletters
    },
    setNewsletter(state, newsletter){
        state.newsletter = newsletter
    },

    setNotifications(state, notifications){
        state.notifications = notifications
    },
    setNotification(state, notification){
        state.notification = notification
    },

    setUsers(state, users){
        state.users = users
    },

    setNotices(state, notices){
        state.notices = notices
    },
    setNotice(state, notice){
        state.notice = notice
    },

    setToday(state, today){
        state.today = today
    },

    setDashboard(state, dashboard){
        state.dashboard = dashboard
    },

    setSubscribers(state, subscribers){
        state.subscribers = subscribers
    },

    setIssueNo(state, no){
        state.issueNo = no
    }
}